import { render } from "./chart-ppm.vue?vue&type=template&id=069b51f0&ts=true"
import script from "./chart-ppm.ts?vue&type=script&lang=ts"
export * from "./chart-ppm.ts?vue&type=script&lang=ts"

import "./chart-ppm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__